import { render, staticRenderFns } from "./taskList.vue?vue&type=template&id=cdac56f0&scoped=true"
import script from "./taskList.vue?vue&type=script&lang=js"
export * from "./taskList.vue?vue&type=script&lang=js"
import style0 from "./taskList.vue?vue&type=style&index=0&id=cdac56f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdac56f0",
  null
  
)

export default component.exports